import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { QUERY_KEYS } from "./queryKeys";

export function useDeployment(projectId?: string, deploymentId?: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.DEPLOYMENTS, deploymentId],
    queryFn: () => {
      if (!projectId) {
        throw new Error("projectId is required");
      }
      if (!deploymentId) {
        throw new Error("deploymentId is required");
      }
      return api.getDeployment(projectId, deploymentId);
    },
    enabled: !!projectId && !!deploymentId,
  });
}
